export default "__VITE_ASSET__718ea534__"